import { IOrder } from 'Order/types/store';
import { objectIsEmpty } from 'shared/utils/objectHelper';

export const isEmptyBillingAndContact = (order: IOrder): boolean =>
  objectIsEmpty(order.orderContact) &&
  objectIsEmpty(order.operationalContact) &&
  !order.billingContactAndAddress.purchaseOrderRef;
